import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { formatUtcDate } from '../../utils/formatters';

export const SimilarTransactionsModal = ({
  show,
  onHide,
  originalTx,
  similarTxs,
  selectedSimilarIds,
  setSelectedSimilarIds,
  formatCurrency,
  onPostJustThisOne,
  onPostAllSelected
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Bulk Post Matching Transactions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You are posting the transaction: <strong>{originalTx?.description}</strong> for <strong>{originalTx?.amount >= 0 ? formatCurrency(originalTx.amount) : `(${formatCurrency(Math.abs(originalTx?.amount))})`}</strong>.
        </p>
        <p>
          We found <strong>{similarTxs.length}</strong> other matching pending transaction(s) with the description: <strong>"{originalTx?.description}"</strong>. 
          Do you want to automatically set their Category, Payee, and Class to match and post them as well?
        </p>
        
        <div className="table-responsive" style={{ maxHeight: '250px', overflowY: 'auto' }}>
          <table className="table table-sm table-striped">
            <thead>
              <tr>
                <th style={{ width: '40px' }}>
                  <input 
                    type="checkbox" 
                    checked={selectedSimilarIds.length === similarTxs.length} 
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedSimilarIds(similarTxs.map(t => t._id));
                      } else {
                        setSelectedSimilarIds([]);
                      }
                    }} 
                  />
                </th>
                <th>Date</th>
                <th>Description</th>
                <th className="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              {similarTxs.map(tx => (
                <tr key={tx._id}>
                  <td>
                    <input 
                      type="checkbox" 
                      checked={selectedSimilarIds.includes(tx._id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSimilarIds(prev => [...prev, tx._id]);
                        } else {
                          setSelectedSimilarIds(prev => prev.filter(id => id !== tx._id));
                        }
                      }}
                    />
                  </td>
                  <td>{formatUtcDate(tx.date)}</td>
                  <td>{tx.description}</td>
                  <td className="text-right font-weight-bold">{tx.amount >= 0 ? formatCurrency(tx.amount) : `(${formatCurrency(Math.abs(tx.amount))})`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onPostJustThisOne}>
          No, Just Post This One
        </Button>
        <Button variant="primary" disabled={selectedSimilarIds.length === 0} onClick={onPostAllSelected}>
          Confirm & Post All Selected ({selectedSimilarIds.length})
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
